module.exports = __webpack_public_path__ + "img/can_rsv.01b1b19b.png";